import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './styles.scss';

const Logo = () => {
  const { labels } = useLanguage();
  const commonLabels = labels.commonLabels || {};
  return (
    <div className="banner">
      <div className="altitude-text">{commonLabels.ALTITUDE}</div>
      <div className="subtitle">{commonLabels.CREW_INTERFACE}</div>
    </div>
  );
};

export default Logo;
